import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { SubscriptionsEdit } from './SubscriptionsEdit'
import { ISubscriptionsEditDispatchProps, ISubscriptionsEditStateProps } from './types'
import { IState } from '../../../../store/types'
import { IPlanHospital } from '../types'
import { updateHospital, fetchHospitals } from '../../../../store/hospitals/actions'
import { IChangedSubscription } from '../../../../types/subscription'
import { IHospitalToUpdate } from '../../../../types/hospital'
import { fetchPlans } from '../../../../store/plans/actions'
import { fetchSubscriptions } from '../../../../store/subscriptions/actions'

const mapStateToProps = (state: IState): ISubscriptionsEditStateProps => {
  return {
    hospitals: state.hospitals,
    subscriptions: state.subscriptions,
    plans: state.plans
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): ISubscriptionsEditDispatchProps => {
  return {
    fetchHospitals: () => {
      return dispatch(fetchHospitals())
    },
    fetchPlans: () => {
      return dispatch(fetchPlans())
    },
    fetchSubscriptions: (hospitalId: string) => {
      return dispatch(fetchSubscriptions(hospitalId))
    },
    updateHospital: (hospital: IPlanHospital) => {
      const hospToSubmit: IHospitalToUpdate = {
        ...hospital,
        subscriptions: [],
        created: hospital.created,
        updated: hospital.updated,
      }
      const subsToSubmit: IChangedSubscription[] = Object.keys(hospital.subscriptions).map(
        s => hospital.subscriptions[s]
      )
      return dispatch(updateHospital(hospToSubmit, subsToSubmit))
    }
  }
}

const SubscriptionsEditContainer = connect(mapStateToProps, mapDispatchToProps)(SubscriptionsEdit)

export {
  SubscriptionsEditContainer
}
